import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGetCemeteriesController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGetCemeteriesController.php
* @route '/api/company/{company}/elys/municipalities/{niscode}/cemeteries'
*/
const ElysGetCemeteriesController = (args: { company: string | number | { id: string | number }, niscode: string | number } | [company: string | number | { id: string | number }, niscode: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ElysGetCemeteriesController.url(args, options),
    method: 'get',
})

ElysGetCemeteriesController.definition = {
    methods: ["get","head"],
    url: '/api/company/{company}/elys/municipalities/{niscode}/cemeteries',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGetCemeteriesController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGetCemeteriesController.php
* @route '/api/company/{company}/elys/municipalities/{niscode}/cemeteries'
*/
ElysGetCemeteriesController.url = (args: { company: string | number | { id: string | number }, niscode: string | number } | [company: string | number | { id: string | number }, niscode: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            company: args[0],
            niscode: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
        niscode: args.niscode,
    }

    return ElysGetCemeteriesController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace('{niscode}', parsedArgs.niscode.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGetCemeteriesController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGetCemeteriesController.php
* @route '/api/company/{company}/elys/municipalities/{niscode}/cemeteries'
*/
ElysGetCemeteriesController.get = (args: { company: string | number | { id: string | number }, niscode: string | number } | [company: string | number | { id: string | number }, niscode: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ElysGetCemeteriesController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysGetCemeteriesController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysGetCemeteriesController.php
* @route '/api/company/{company}/elys/municipalities/{niscode}/cemeteries'
*/
ElysGetCemeteriesController.head = (args: { company: string | number | { id: string | number }, niscode: string | number } | [company: string | number | { id: string | number }, niscode: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ElysGetCemeteriesController.url(args, options),
    method: 'head',
})

export default ElysGetCemeteriesController